import React from 'react'
import "./SliderProductImage.css"
import useCheckAccess from '../../hooks/useCheckAccess/useCheckAccess'
import SliderProductImageCard from './SliderProductImageCard/SliderProductImageCard'
import { ProductImageDB } from '../../../redux/slices/components/ProductsImages/ProductsImagesSlice'

interface SliderProductImageProps {
  sliderData: ProductImageDB[]
}

const SliderProductImage = ({ sliderData }: SliderProductImageProps) => {

    const accessEdit = useCheckAccess({ id_Category: "Verify", id_Policy: "Products", id_Action: "Edit" })

    return (
        <div className="p-relative mt-20">
          <div id="con-gray-slider-product" className="rec-gray-slider-product"> 
              {
                  sliderData.map((product: any, index: number) => {
                      return(
                          <SliderProductImageCard
                              key={product.id}
                              product={product}
                              index={index}
                              lengthProduct={sliderData.length}
                              editable={accessEdit}
                          />
                      )
                  })
              }
          </div>
      </div>
    )
}

export default React.memo( SliderProductImage )